import React from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import {
  MdOutlineDashboard,
  MdDashboard,
  MdOutlinePeople,
  MdPeople,
  MdOutlinePersonSearch,
  MdPersonSearch,
  MdOutlineRealEstateAgent,
  MdRealEstateAgent,
  MdListAlt,
  MdOutlineHomeWork,
  MdHomeWork,
  MdOutlineManageAccounts,
  MdManageAccounts,
  MdOutlineSettings,
  MdSettings,
  MdOutlineStreetview,
  MdStreetview,
} from "react-icons/md";

const SideBar = ({ open, setOpen }) => {
  const navigate = useNavigate();
  const Menus = [
    {
      title: "Dashboard",
      src: "dashboard",
      href: "",
      link: "/",
      iconOutline: <MdOutlineDashboard className='text-2xl ml-2 text-black' />,
      iconFilled: <MdDashboard className='text-2xl ml-2' />,
    },
    {
      title: "AddressBook",
      src: "addressbook",
      href: "addressbook",
      link: "/addressbook",
      iconOutline: <MdOutlinePeople className='text-2xl ml-2' />,
      iconFilled: <MdPeople className='text-2xl ml-2' />,
    },
    {
      title: "Enquiry",
      src: "enquiry",
      href: "enquiry",
      link: "/enquiry",
      iconOutline: <MdOutlinePersonSearch className='text-2xl ml-2' />,
      iconFilled: <MdPersonSearch className='text-2xl ml-2' />,
    },
    {
      title: "Service",
      src: "services",
      href: "serviceticket",
      link: "/serviceticket",
      iconOutline: <MdOutlineRealEstateAgent className='text-2xl ml-2' />,
      iconFilled: <MdRealEstateAgent className='text-2xl ml-2' />,
    },
    {
      title: "Tasks",
      src: "tasks",
      href: "servicetask",
      link: "/servicetask",
      iconOutline: <MdListAlt className='text-2xl ml-2' />,
      iconFilled: <MdListAlt className='text-2xl ml-2' />,
    },
    {
      title: "Meetings",
      src: "meetings",
      href: "meetings",
      link: "/meetings",
      iconOutline: <MdOutlineStreetview className='text-2xl ml-2' />,
      iconFilled: <MdStreetview className='text-2xl ml-2' />,
    },
    {
      title: "Properties",
      src: "property",
      href: "property",
      link: "/property",
      // gap: true,
      iconOutline: <MdOutlineHomeWork className='text-2xl ml-2' />,
      iconFilled: <MdHomeWork className='text-2xl ml-2' />,
    },
    {
      title: "Accounts",
      src: "user-accounts",
      href: "user",
      link: "/user/manage-user-accounts",
      // gap: true,
      header: "APPS",
      iconOutline: <MdOutlineManageAccounts className='text-2xl ml-2' />,
      iconFilled: <MdManageAccounts className='text-2xl ml-2' />,
    },
    {
      title: "Settings",
      src: "settings",
      href: "admin",
      link: "/admin/form-input-settings",
      iconOutline: <MdOutlineSettings className='text-2xl ml-2' />,
      iconFilled: <MdSettings className='text-2xl ml-2' />,
    },
  ];

  const isCurrentPage = (href) => {
    const currentUrl = window.location.pathname;
    return currentUrl.split("/")[1].toLowerCase() === href.toLowerCase();
  };

  React.useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "smooth",
    });
    function onKeydown(event) {
      if (event.key === "/" && (event.metaKey || event.ctrlKey)) {
        event.preventDefault();
        setOpen(!open);
      }
    }

    window.addEventListener("keydown", onKeydown);
    return () => {
      window.removeEventListener("keydown", onKeydown);
    };
  }, [open]);

  return (
    <div className='flex-none hidden lg:block'>
      <div
        className={`${
          open ? "w-72 bg-gray-dark/70" : "w-0 sm:w-20 bg-gray-50"
        }  h-screen p-5 overflow-y-auto pt-8 relative duration-300`}>
        <img
          src='/assets/icons/control.png'
          alt='>'
          className={`z-40 absolute cursor-pointer -right-3 top-9 w-7 
           border-2 rounded-full `}
          onClick={() => setOpen(!open)}
          title="Collapse 'Ctrl + /'"
        />
        <div className='flex gap-x-4 items-center'>
          <img
            src={`/favicon.jpg`}
            alt='LL'
            className={`cursor-pointer p-2 rounded bg-white w-24 duration-500 `}
          />
          <h1
            className={`cursor-default text-yellow-2 origin-left h-10 font-medium text-xl duration-200 p-1 ${
              open ? "scale-100 duration-400 block" : "scale-0 hidden"
            }`}>
            L&amp;L ERP
          </h1>
        </div>
        <ul className='pt-6'>
          {Menus.map((Menu, index) => (
            <li
              key={index}
              className={`flex py-2 ${
                open ? "px-2 rounded-sm" : "px-0 rounded-md"
              } duration-300 cursor-pointer ${
                isCurrentPage(Menu.href)
                  ? "bg-yellow-dark text-gray-dark font-semibold"
                  : `hover:text-gray-dark hover:bg-yellow-2 hover:font-semibold ${
                      open ? "text-white" : "text-gray-dark"
                    }`
              } text-sm items-center gap-x-4 
              ${Menu.gap ? "mt-9" : "mt-2"} ${
                index === 0 && "bg-light-white"
              } `}
              onClick={(e) => {
                navigate(Menu.link, { replace: false });
              }}
              title={Menu.title}>
              {/* <img
                className={`h-7 w-7 ml-1.5`}
                src={`/assets/icons/${
                  isCurrentPage(Menu.href)
                    ? Menu.src + "-filled"
                    : open
                    ? Menu.src + "-white"
                    : Menu.src
                }.png`}
                alt={Menu.src}
                title={Menu.title}
              /> */}
              {isCurrentPage(Menu.href) ? Menu.iconFilled : Menu.iconOutline}
              <span className={`${!open && "hidden"} origin-left duration-200`}>
                {Menu.title}
              </span>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};
export default SideBar;
